import Md5 from "js-md5";
import {getToken, getUser} from "../storage/user";

export default function callSkyduck(uri, authorized, body, headers) {
    if (body) {
        return fetch(uri, {
            method: 'POST',
            headers: authorized ? authorizedHeaders(uri, body, headers) : anonymousHeaders(uri, body, headers),
            body: JSON.stringify(body)
        });
    } else {
        return fetch(uri, {
            method: 'GET',
            headers: authorized ? authorizedHeaders(uri, body, headers) : anonymousHeaders(uri, body, headers)
        });
    }
}

function authorizedHeaders(uri, body, headers) {
    return Object.assign({
        'userID': getUser(),
        'token': getToken(),
        'crc': body
            ? crcForRequest(uri, 'POST', getUser(), getToken(), JSON.stringify(body))
            : crcForRequest(uri, 'GET', getUser(), getToken(), null),
    }, headers);
}

function anonymousHeaders(uri, body, headers) {
    return Object.assign({
        'crc': body
            ? crcForRequest(uri, 'POST', '', '', JSON.stringify(body))
            : crcForRequest(uri, 'GET', '', '', null)
    }, headers);
}

export function crcForRequest(uri, httpMethod, userId, token, body) {
    if(httpMethod === 'GET') {
        return Md5("jumpy" + uri + userId + token + "daBest");
    }

    if(httpMethod === 'POST') {
        return Md5(
            "jumpy" + uri + userId + token
            + body.toString()
            + "daBest"
        )
    }
}